import { render, staticRenderFns } from "./SaleMobile.vue?vue&type=template&id=895d8ea8&"
import script from "./SaleMobile.vue?vue&type=script&lang=js&"
export * from "./SaleMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports